<template>
<div class="selectAddressSearch-component">
    <van-sticky :z-index="99" :class="{notTop: isWeixin || isApp}">
        <div class="searchBox">
            <i class="ico ico-icon_52" @click="jumpSelectCity()"></i>
            <span class="city" @click="jumpSelectCity()">{{city | toSubStr}}</span>
            <i class="ico ico-icon_down" @click="jumpSelectCity()"></i>
            <div class="inputBox">
                <i class="ico ico-icon_61"></i>
                <input type="text" v-model="inputAddress" placeholder="请输入地址" @input="onInput" @focus="inputFocus" @blur="inputBlur" />
                <i class="ico ico-icon_02 close" v-show="inputAddress !==''" @click="onClearInput"></i>
            </div>
        </div>
    </van-sticky>
    <div class="address-box" :class="{'address-box-height-weixin': isWeixin, 'address-box-height' : !isWeixin}" v-if="input_focus">
        <div class="info" v-show="cityList.length">
            <div v-for="(item, index) in cityList" :key="index" class="item" @click="sureAddress(item)">
                <p class="name">{{item.name}}</p>
                <p class="address">{{item.formattedAddress}}</p>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import {
    mapState,
    mapActions,
} from 'vuex'
// import {
//     setLocalConfig,
//     getLocalConfig
// } from '@/utils/storage.js'
import {
    selectAddress
} from '@/models/selectAddress'
import { Sticky } from 'vant'
Vue.use(Sticky)
export default {
    inject: ['showLoading', 'hideLoading'],
    name: 'selectAddressSearch',
    props: {
        city: {
            type: String,
            default: ''
        }
    },
    components: {
    },
    data () {
        return {
            inputAddress: '',
            cityList: [],
            show: true,
            lockScroll: false,
            input_focus: false, // input框聚焦
        }
    },
    created () {

    },
    activated () {

    },
    watch: {
    },
    mounted () {
    },
    computed: {
        ...mapState({
            isWeixin: ({
                appInfo
            }) => appInfo.isWeixin,
            icarAppInfo: ({ appInfo }) => appInfo.icarAppInfo
        }),
        isApp () {
            return this.icarAppInfo.app_name === 'iCar_app'
        },
    },
    methods: {
        ...mapActions([
            'saveAddressInfo',
        ]),
        /**
         * 清空文本框
         */
        onClearInput () {
            this.cityList = []
            this.inputAddress = ''
            this.input_focus = false
        },
        onInput: _.debounce(function () {
            if (!this.inputAddress) {
                this.cityList = []
            } else {
                let params = {
                    city: this.city,
                    keyword: this.inputAddress,
                    page: 1,
                    pagesize: 10
                }
                this.showLoading()
                selectAddress(params)
                    .then(res => {
                        this.cityList = res.list
                        this.hideLoading()
                    })
                    .catch(() => {
                        this.hideLoading()
                    })
            }
        }, 200),
        inputFocus () {
            this.input_focus = true
        },
        inputBlur () {
            // this.input_focus = false
            if (!this.cityList.length) {
                this.input_focus = false
            }
        },
        // 选择地址
        sureAddress (item) {
            console.log(item)
            this.saveAddressInfo(item)
            this.$emit('updateAddress', this.inputAddress)
        },
        // 跳转选择城市
        jumpSelectCity () {
            this.$router.push({
                name: 'selectCityList',
                query: {
                    city: this.city
                }
            })
        }
    }
}
</script>

<style lang="stylus">
@import '~@/assets/stylus/variables'
.selectAddressSearch-component
    .van-sticky
        background $fcWhite
        &.van-sticky--fixed
            top 88px
    .notTop
        .van-sticky--fixed
            top 0
    .searchBox
        padding 14px 30px 14px 30px
        box-sizing border-box
        display flex
        justify-content center
        align-items center
        background #fff
        // position relative
        .ico-icon_52
            margin-right 12px
        .city
            margin-right 22px
        .ico-icon_down
            margin-right 22px
        .inputBox
            flex 1
            position relative
            input
                padding 0 55px 0 60px
                color #333
                width 100%
                box-sizing border-box
                height 60px
                border-radius 30px
                display block
                background #efefef
            .ico-icon_61
                position absolute
                top 10px
                left -1000px
                filter: drop-shadow(1014px 0 0 #999999);
            .close
                position absolute
                right 10px
                top 8px
                transform scale(0.7)
                transform-origin: center center
        // .top-90
        //     top 88px
        // .top-180
        //     top 176px
    .address-box
        width 100%
        // height calc(100vh - 176px)
        overflow-y scroll
        background rgba(0,0,0,.7)
        position absolute
        z-index 88
        .info
            background #fff
            opacity 1
            z-index 89
            &:first-child
                    border-top 1px solid #eee
            .item
                box-sizing border-box
                border-bottom 1px solid #eee
                padding 20px 0

                .name
                    font-size $fontlessBase
                    color $inputTextColor
                    padding 0 30px
                .address
                    font $fontLeastSmall
                    color $fcGreyish
                    padding 9px 30px 0
    .address-box-height
        height calc(100vh - 176px)
    .address-box-height-weixin
        height calc(100vh - 88px)
</style>
